import React, { useState, useEffect } from 'react';
import './header.css';
// Importer FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome,
  faCogs,
  faUsers,
  faEnvelope,
  faPhone,
  faArrowRight,
  faTimes,
  faBars,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import { 
  faLinkedinIn, 
  faFacebook, 
  faTiktok 
} from '@fortawesome/free-brands-svg-icons';

const HEADER = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('accueil');

  // Gestion du scroll
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);

      const sections = ['accueil', 'services', 'projets', 'apropos', 'contact'];

      const currentSection = sections.find((section) => {
        const element = document.getElementById(section);
        if (!element) return false; // Sécurisation

        const rect = element.getBoundingClientRect();
        return rect.top <= 100 && rect.bottom >= 100;
      });

      if (currentSection) setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll fluide sécurisé
  const scrollToSection = (sectionId, e) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (!element) return; // Évite crash

    const headerHeight = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });

    setActiveSection(sectionId);
    setIsMenuOpen(false);
  };

  // Remonter en haut
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setActiveSection('accueil');
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="container">
        <nav className="navbar">

        <div className='logo'>
          <img src="/images/LOGO_.png" alt="FOND D'ECRAN" className='logo-image' />
        </div>
        

          {/* Navigation Desktop */}
          <div className="nav-desktop">
            <ul className="nav-links">
              <li>
                <button
                  className={`nav-link ${activeSection === 'accueil' ? 'active' : ''}`}
                  onClick={(e) => scrollToSection('accueil', e)}
                >
                  <span className="nav-text">Accueil</span>
                  <span className="nav-indicator"></span>
                </button>
              </li>

              <li>
                <button
                  className={`nav-link ${activeSection === 'services' ? 'active' : ''}`}
                  onClick={(e) => scrollToSection('services', e)}
                >
                  <span className="nav-text">Services</span>
                  <span className="nav-indicator"></span>
                </button>
              </li>

              <li>
                <button
                  className={`nav-link ${activeSection === 'apropos' ? 'active' : ''}`}
                  onClick={(e) => scrollToSection('apropos', e)}
                >
                  <span className="nav-text">À propos</span>
                  <span className="nav-indicator"></span>
                </button>
              </li>
            </ul>

            <button className="cta-button" onClick={(e) => scrollToSection('contact', e)}>
              <span className="cta-text">Nous contacter</span>
              <span className="cta-icon">
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </button>
          </div>

          {/* Bouton menu mobile */}
          <button
            className={`menu-toggle ${isMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menu"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </nav>
      </div>

      {/* Menu Mobile */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <div className="mobile-menu-header">
            <div className="mobile-logo" onClick={scrollToTop}>
              <span className="mobile-logo-text">MOSE RAI GC</span>
              <span className="mobile-logo-subtitle">Solutions Numériques Innovantes</span>
            </div>

            <button className="mobile-close" onClick={() => setIsMenuOpen(false)} aria-label="Fermer le menu">
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <ul className="mobile-nav-links">
            {[
              { id: 'accueil', icon: faHome, label: 'Accueil' },
              { id: 'services', icon: faCogs, label: 'Services' },
              { id: 'apropos', icon: faUsers, label: 'À propos' },
              { id: 'contact', icon: faEnvelope, label: 'Contact' }
            ].map((item) => (
              <li key={item.id}>
                <button
                  className={`mobile-nav-link ${activeSection === item.id ? 'active' : ''}`}
                  onClick={(e) => scrollToSection(item.id, e)}
                >
                  <span className="mobile-nav-icon">
                    <FontAwesomeIcon icon={item.icon} />
                  </span>
                  <span className="mobile-nav-text">{item.label}</span>
                  <span className="mobile-nav-arrow">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </span>
                </button>
              </li>
            ))}
          </ul>

          <div className="mobile-contact-info">
            <div className="mobile-contact-item">
              <span className="mobile-contact-icon">
                <FontAwesomeIcon icon={faPhone} />
              </span>
              <div className="mobile-contact-details">
                <span className="mobile-contact-label">Téléphone</span>
                <span className="mobile-contact-value">+229 01 62 60 49 43</span>
              </div>
            </div>

          </div>

          <div className="mobile-social">
            <a href="https://www.linkedin.com/company/mose-rai-gc/" target="_blank" rel="noopener noreferrer" className="mobile-social-link">
              <FontAwesomeIcon icon={faLinkedinIn} /> LinkedIn
            </a>
            <a href="https://www.facebook.com/moseraiglobalcorp/" target="_blank" rel="noopener noreferrer" className="mobile-social-link">
              <FontAwesomeIcon icon={faFacebook} /> Facebook
            </a>
            <a href="https://www.tiktok.com/@moseraiglobalcorp" target="_blank" rel="noopener noreferrer" className="mobile-social-link">
              <FontAwesomeIcon icon={faTiktok} /> TikTok
            </a>
          </div>
        </div>

        {/* Overlay */}
        <div className="mobile-menu-overlay" onClick={() => setIsMenuOpen(false)}></div>
      </div>
    </header>
  );
};

export default HEADER;